import { __assign } from "tslib";
import React from "react";
import { colors } from "../../theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "./Typography";
import { faCircleMinus, faCirclePlus, } from "@fortawesome/pro-solid-svg-icons";
import { faFileCertificate } from "@fortawesome/pro-regular-svg-icons";
import { IconButton } from "./IconButton";
import { DisplayTypeToIconMap } from "../graphical/ResourceTypesIcons";
import { MenuButton } from "./MenuButton";
import { FlexRow } from "../layout/FlexRow";
import { SelectDropDown } from "./SelectDropDown";
export var UserGroupBar = function (_a) {
    var type = _a.type, name = _a.name, leftIcon = _a.leftIcon, caption = _a.caption, _b = _a.selected, selected = _b === void 0 ? false : _b, _c = _a.assigned, assigned = _c === void 0 ? false : _c, onClickAddButton = _a.onClickAddButton, onClickRemoveButton = _a.onClickRemoveButton, _d = _a.width, width = _d === void 0 ? '394px' : _d, style = _a.style, _e = _a.endButton, endButton = _e === void 0 ? true : _e, showPermissionsMenu = _a.showPermissionsMenu, permissionsMenuValue = _a.permissionsMenuValue, onChangePermissionsMenu = _a.onChangePermissionsMenu, menuItems = _a.menuItems, onClick = _a.onClick;
    return (React.createElement("div", { style: __assign({ backgroundColor: selected ? colors.blue[5] : colors.white, width: width, minWidth: '265px', minHeight: '63px', paddingTop: '12px', paddingBottom: '12px', paddingRight: '12px', paddingLeft: '16px', display: 'flex', justifyContent: 'space-between', boxSizing: 'border-box' }, style) },
        React.createElement("div", { onClick: onClick, style: {
                display: 'flex',
                gap: '8px',
                cursor: 'pointer',
                minWidth: '28px'
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    minWidth: '28px'
                } }, leftIcon ?
                React.createElement(FontAwesomeIcon, { icon: leftIcon, color: '#b8bdc6' })
                :
                    type === 'POLICY' ?
                        React.createElement(FontAwesomeIcon, { icon: faFileCertificate, color: '#b8bdc6' })
                        :
                            React.createElement("img", { src: DisplayTypeToIconMap[type], style: {
                                    width: '28px',
                                    height: '28px'
                                } })),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    alignItems: 'flex-start',
                    width: '100%',
                    minWidth: 0
                } },
                React.createElement("div", { style: {
                        width: '100%',
                        minWidth: 0
                    } },
                    React.createElement(Typography, { variant: 'inputText-typed', truncate: true, truncateWidth: '100%' }, name),
                    React.createElement(Typography, { variant: 'breadcrumbLink', truncate: true, truncateWidth: '100%' }, caption)))),
        React.createElement(FlexRow, { justifyContent: 'flex-end', alignItems: 'center', columnGap: '8px' },
            showPermissionsMenu ?
                React.createElement(SelectDropDown, { style: { width: '100px' }, value: permissionsMenuValue, onChange: onChangePermissionsMenu, showHelpText: false, menuItems: [
                        {
                            value: "read",
                            label: 'Read',
                            selected: true
                        },
                        {
                            value: "write",
                            label: 'Write'
                        },
                        {
                            value: "admin",
                            label: 'Admin'
                        },
                        {
                            value: "owner",
                            label: 'Owner'
                        },
                    ] })
                :
                    null,
            type === 'POLICY' ?
                React.createElement(MenuButton, { menuItems: menuItems })
                :
                    endButton ?
                        React.createElement(IconButton, { icon: assigned ? faCircleMinus : faCirclePlus, variant: assigned ? 'gray' : 'grayBlue', size: 'sm', onClick: assigned ? onClickRemoveButton : onClickAddButton })
                        :
                            null)));
};
